module.exports = __webpack_public_path__ + "img/10.c845cd74.jpg";